// Copyright (c) 2020 Verimatrix, Inc.  All Rights Reserved.

import React from 'react'
import ReactDOM from 'react-dom'

import AreYouThere from '..'

const AreYouTherePortal = () => {
  return ReactDOM.createPortal(
    <div>
      <AreYouThere/>
    </div>,
    document.getElementById('modal')
  )
}

export default AreYouTherePortal
